import React, { useState } from 'react';
import { DateField, List, Datagrid, TextField, useRecordContext, SimpleShowLayout, Show,
  BulkDeleteButton, BulkUpdateButton, useShowController, Labeled, Link } from 'react-admin';
import styles from './styles/filtersLayout.module.css';
import { NoBidChartComponent } from './components/chart.js';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@material-ui/core';

const choicesType = require('./components/metrics.json')

export const AlarmList = ({ permissions, ...props }) => (
  <List {...props} title="Alarms" perPage={25} bulkActionButtons={<AlarmBulkAction />} exporter={false} >
    <Datagrid className={styles.buttonRight} rowClick="show" rowStyle={(r) => { if(!r.opened_at) return { backgroundColor: '#606060'} }}>
      <TextField source="code"/>
      <DateField source="created_at" label="Alarm Date" showTime/>
      <TextField source="type" label="Type" />
      if (record?.source) {
        <TextField source="source" label="Source" />
      }
      <TextField source="message" label="Message" />
      {/* <Preview /> */}
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

export const AlarmShow = (props) => { 
  const { record } = useShowController(props);
  return (
    <Show title={<AlarmTitle />} {...props}>
      <SimpleShowLayout >
        <div>Source: {record?.source}</div>
        <div style={{display: 'flex', gap: '30px'}}>
          <Labeled label='ID'><TextField label='ID' source='code'/></Labeled>
          <Labeled label='Date'><DateField source="created_at" label="Date" showTime/></Labeled>
          <Labeled label='Type'><TextField label='Type' source='type'/></Labeled>
        </div>
        <TextField label='Message' source='message'/>
        
        { record?.preview_data &&
        <>
          <div className='MuiTypography-body2'>
            <p><Link to={`/realtime/${record?.preview_data?.source}`} target='_blank'>Realtime Report...</Link></p>
            <p>The following Anomal{record?.preview_data.anomalies.length > 1 ? 'ies were' : 'y was'} detected:</p>
            <ul>
              {record?.preview_data.anomalies.map(x => <li><b>{x[3].toFixed(2)}% {x[2]}</b> on {new Date(x[0]).toString()}</li>)}
            </ul>
          </div>
          <Chart/>
        </> }
      </SimpleShowLayout>
    </Show>
  );
}

const AlarmBulkAction = (props) => (
  <>
    <BulkUpdateButton
      label='Acknowledge'
      data={{opened_at: new Date()}}
      {...props}
    />
    <BulkDeleteButton {...props}/>
  </>
);

const Chart = (props) => {
  const record = useRecordContext();
  const {realData, expectedData, min, max} = record?.preview_data
  const series = [
    { name: choicesType.find(x=> x.id === record?.metric)?.name, type: 'column', color: 'yellow', xAxis: 0, data: realData.map(x => [new Date(x[0]).getTime(), x[1]]) },
    { name: 'Moving Average', type: 'line', color: 'red', xAxis: 0, data: expectedData.map(x => ({x: new Date(x[0]).getTime(), y: x[1]})) },
    { name: 'Safe Range', type: 'arearange', color: '#dddddd80', xAxis: 0, data: expectedData.map(x => ({x: new Date(x[0]).getTime(), low: Number((x[1]-(x[1]*(Number(min)/100))).toFixed(2)), high: Number((x[1]*((Number(max)/100)+1)).toFixed(2))})) }
  ]

  return (
    <NoBidChartComponent
      config={{height: '40%', width: '100%', min: 0, xformat: '%e-%b %H:%M', color: 'limegreen'}}
      series={series}
      plotOptions={{arearange: { marker: { enabled: false } }, line: { marker: { enabled: false } } }}
    />
  )
}

const AlarmTitle = ({ record }) => {
  return <span>Alarm {record ? `"${record.type}: ${record.message}"` : ''}</span>;
};

const Preview = (props) => {
  const [showDialog, setShowDialog] = useState(false);
  const handleClick = () => {
    setShowDialog(true);
  };
  const handleCloseClick = () => {
    setShowDialog(false);
  };

  // console.log(props?.record)

  if (props?.record?.preview_data) {
    // console.log('=> ', props?.record?.preview_data)
    // return <Button label='Preview' color='secondary' onClick={handleClick}/>
    return (
      <>
        <Button variant='outlined' onClick={handleClick} >Preview</Button>
        <Dialog
          maxWidth="md"
          fullWidth
          open={showDialog}
          onClose={handleCloseClick}
          aria-label="Create post"
        >
         <DialogTitle>Preview</DialogTitle>
         <DialogContent>
          <NoBidChartComponent
            config={
              {
                height: '40%', width: '100%', min: 0, xformat: '%e-%b %H:%M', color: 'limegreen'
              }
            }
            series={[{name: choicesType.find(x=> x.id === props?.record?.metric)?.name, xAxis: 0, data: props?.record?.preview_data.map(x => [new Date(x[0]).getTime(), x[1]])}]}
            plotOptions={{arearange: { marker: { enabled: false } }, line: { marker: { enabled: false } } }}
          />
         </DialogContent>
         <DialogActions></DialogActions>
        </Dialog>
      </>
    )
  }
  return null;
}
